// imports
import JsonApiModel from '$dependencies/JsonApiModel';

// private static properties
const API_DICTIONARY = {
	uuid: 'id',
	drupal_internal__tid: 'tid',
};

const FIELDS = {
	id: { type: String, default: '', identifier: true },
	name: { type: String, default: '' },
	tid: { type: Number, default: -1 },
};

// class definition
export default class StatusModel extends JsonApiModel {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.fields = FIELDS;
		args.entityType = 'taxonomy_term--incident_status';

		// json api settings
		args.jsonApi = Object.assign(args.jsonApi || {}, {
			dictionary: API_DICTIONARY,
		});

		// call super constructor
		super(args);
	}

	// methods
	destroy() {}

	// utility methods

	// getters & setters
	get urlKey() {
		return this.name.toLowerCase().replace(' ', '-');
	}
}
